import axiosInstance from "../utils/axiosInstance";
import { useDispatch } from "react-redux";
import { clearUserData } from "../store/userSlice.js";
import { broadcastSessionLogout } from "./sessionSync";

import { invalidateUserFetches } from "./refreshSessionData";
import { hardRedirect } from "./hardRedirect";

// navigate is optional; pass it from components that have useNavigate available
// so the logout stays a SPA transition instead of a full page reload.
export async function logout(dispatch, navigate) {
  try {
    localStorage.removeItem("popupShown");
    invalidateUserFetches();
    await axiosInstance.get("/api/auth/logout");
    dispatch(clearUserData());
    broadcastSessionLogout();
    if (typeof navigate === "function") {
      navigate("/", { replace: true });
    } else {
      hardRedirect("/");
    }
  } catch (err) {
    console.error("Logout error:", err);
  }
}
